import TextField from '@mui/material/TextField';
import { useAuthSubmit } from 'src/hooks/useAuthSubmit';

export type EmailInput = 'email';

export const AuthenticationEmailInput = () => {
  const { userCredentials, errors, onInputChange } = useAuthSubmit();

  return (
    <TextField
      error={errors.email}
      helperText={
        errors.email ? 'Please enter a valid email address!' : undefined
      }
      label="Email Address"
      type={'email'}
      InputLabelProps={{ shrink: true }}
      variant="outlined"
      sx={{
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgb(192, 192, 192)',
        },
        mb: '20px',
      }}
      fullWidth={true}
      name={'email'}
      value={userCredentials.email}
      onChange={(event) => onInputChange('email', event)}
      disabled={true}
    />
  );
};
